var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6731 6.43793L5.29769 2.88349C5.48926 2.69572 5.51343 2.68782 5.71216 2.88349L9.32691 6.43793V10.0029H6.64136V7.59438C6.64112 7.51603 6.60926 7.44095 6.55274 7.38555C6.49621 7.33015 6.41962 7.29892 6.33968 7.29869H4.66211C4.58217 7.29892 4.50558 7.33015 4.44905 7.38555C4.39253 7.44095 4.36067 7.51603 4.36043 7.59438V10.0029H1.67489V6.43793H1.6731ZM5.38631 0.0774882L0 5.03493L1.32845 5.71845L5.13298 1.95781C5.45882 1.63667 5.4624 1.62965 5.78556 1.94377L9.67155 5.71669L11 5.03318L5.60563 0.0695913C5.50895 -0.018151 5.49463 -0.0295576 5.38631 0.0774882Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.c53a0abb3f78be6963adf8deae343154.svg";
export { ForwardRef as ReactComponent };